import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Auth } from "aws-amplify";
import { setCurrentUser } from "../../redux/actions/currentUserActions";
import { Amplify } from "aws-amplify";
import config from "config";
import { RootState } from "redux/reducers/rootReducer";

interface Props {
  userHasAuthenticated: (authenticated: boolean) => void;
}

const SignOutButton = ({ userHasAuthenticated }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const currentUser = useSelector((state: RootState) => state.currentUser);

  useEffect(() => {
    Amplify.configure({
      Auth: config.COGNITO_AUTH,
    });
  }, []);

  if (!currentUser || Object.keys(currentUser).length === 0) return null;

  const handleSignOut = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await Auth.signOut({ global: true });
      dispatch(setCurrentUser({}));
      userHasAuthenticated(false);
      history.push("/login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <button className="header-settings-language__toggler">
      <a onClick={handleSignOut} className="application-feedback__link">
        <FormattedMessage id="theUserBar.signout" />
      </a>
    </button>
  );
};

export default SignOutButton;
